/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Payment_Choice_Modal_Pay_Advance_ButtonInputs */

const es_components_payment_choice_modal_pay_advance_button = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Advance_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir meses`)
};

const en_components_payment_choice_modal_pay_advance_button = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Advance_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose months`)
};

/**
* | output |
* | --- |
* | "Choose months" |
*
* @param {Components_Payment_Choice_Modal_Pay_Advance_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_payment_choice_modal_pay_advance_button = /** @type {((inputs?: Components_Payment_Choice_Modal_Pay_Advance_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Payment_Choice_Modal_Pay_Advance_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_payment_choice_modal_pay_advance_button(inputs)
	return en_components_payment_choice_modal_pay_advance_button(inputs)
});
export { components_payment_choice_modal_pay_advance_button as "components.payment_choice_modal.pay_advance_button" }